import * as tslib_1 from "tslib";
import { Loader as AwayLoader } from "@awayjs/core";
import { LoaderInfo } from "./LoaderInfo";
import { Bitmap } from "./Bitmap";
import { DisplayObjectContainer } from "./DisplayObjectContainer";
import { LoaderEvent, AssetEvent, WaveAudio } from "@awayjs/core";
import { MovieClip as AwayMovieClip, Sprite as AwaySprite, TextField as AwayTextField } from "@awayjs/scene";
import { Event } from "../events/Event";
import { ProgressEvent } from "../events/ProgressEvent";
import { Font, SceneImage2D } from "@awayjs/scene";
import { Image2DParser } from "@awayjs/stage";
import { FlashSceneGraphFactory } from "../factories/FlashSceneGraphFactory";
import { URLLoaderEvent } from "@awayjs/core";
// todo: define all methods (start new with converting as3-Loader to ts ?)
var Loader = (function (_super) {
    tslib_1.__extends(Loader, _super);
    function Loader(parser) {
        var _this = _super.call(this) || this;
        _this._onLoaderProgressDelegate = function (event) { return _this.onLoaderProgress(event); };
        _this._onLoaderCompleteDelegate = function (event) { return _this.onLoaderComplete(event); };
        _this._onAssetCompleteDelegate = function (event) { return _this.onAssetComplete(event); };
        _this._parser = parser;
        _this._loaderInfo = new LoaderInfo();
        _this._factory = new FlashSceneGraphFactory();
        return _this;
    }
    Loader.prototype.onLoaderProgress = function (event) {
        var newEvent = new ProgressEvent(ProgressEvent.PROGRESS, null, null, event.urlLoader.bytesLoaded, event.urlLoader.bytesTotal);
        newEvent.currentTarget = this._loaderInfo;
        this._loaderInfo.dispatchEvent(newEvent);
    };
    Loader.prototype.onLoaderComplete = function (event) {
        var newEvent = new Event(Event.COMPLETE);
        newEvent.currentTarget = this._loaderInfo;
        this._loaderInfo.dispatchEvent(newEvent);
        this._loader.removeEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoaderCompleteDelegate);
        this._loader.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        this._loader = null;
        //AssetLibrary.removeEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoaderCompleteDelegate);
        //AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
    };
    Loader.prototype.onAssetComplete = function (event) {
        // 	todo: take care of all needed asset-types (sounds / fonts / textfield)
        //	todo: update awd to support as3-class-identifier as extra property. 
        //  atm the name of the exported symbols will be the as3-class name, 
        //  and all exported symbols are handled as if exposed to as3
        var asset = event.asset;
        if (asset.isAsset(AwayTextField)) {
            this._loaderContext.applicationDomain.addDefinition(asset.name, asset);
        }
        else if (asset.isAsset(SceneImage2D)) {
            this._loaderContext.applicationDomain.addDefinition(asset.name, asset);
            // we should only do this for bitmaps loaded from jpg or png
            if (this._isImage)
                this.addChild(this._loaderInfo.content = new Bitmap(asset.adapter));
        }
        else if (asset.isAsset(WaveAudio)) {
            this._loaderContext.applicationDomain.addAudioDefinition(asset.name, asset);
        }
        else if (asset.isAsset(Font)) {
            this._loaderContext.applicationDomain.addFontDefinition(asset.name, asset);
        }
        else if (asset.isAsset(AwaySprite)) {
            //if((<AwaySprite> asset).material)
            //	(<AwaySprite> asset).material.bothSides=false;
            this._loaderContext.applicationDomain.addDefinition(asset.name, asset);
        }
        else if (asset.isAsset(AwayMovieClip)) {
            this._loaderContext.applicationDomain.addDefinition(asset.name, asset);
            // if this is the "Scene 1", we make it a child of the loader
            if (asset.name == "Scene 1" || (asset.name == "scene")) {
                this.addChild(this._loaderInfo.content = asset.adapter);
            }
        }
    };
    Loader.prototype.load = function (url, context) {
        if (context === void 0) { context = null; }
        console.log("start loading the url:" + url.url);
        var ext = url.url.substr(-3);
        this._isImage = (ext == "jpg" || ext == "png");
        url.url = url.url.replace(".swf", ".awd");
        this._loaderContext = context;
        this._loaderInfo.applicationDomain = context.applicationDomain;
        this._loader = new AwayLoader();
        this._loader.addEventListener(URLLoaderEvent.LOAD_PROGRESS, this._onLoaderProgressDelegate);
        this._loader.addEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoaderCompleteDelegate);
        this._loader.addEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        this._loader.load(url, null, null, (this._isImage) ? new Image2DParser(this._factory) : this._parser);
    };
    Loader.prototype.loadData = function (buffer, context) {
        if (context === void 0) { context = null; }
        console.log("start loading swfdata", buffer);
        this._loaderContext = context;
        this._loaderInfo.applicationDomain = context.applicationDomain;
        this._loader = new AwayLoader();
        this._loader.addEventListener(URLLoaderEvent.LOAD_PROGRESS, this._onLoaderProgressDelegate);
        this._loader.addEventListener(LoaderEvent.LOAD_COMPLETE, this._onLoaderCompleteDelegate);
        this._loader.addEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        this._loader.loadData(buffer, null, null, null, this._parser);
    };
    Object.defineProperty(Loader.prototype, "contentLoaderInfo", {
        get: function () {
            return this._loaderInfo;
        },
        set: function (value) {
            this._loaderInfo = value;
        },
        enumerable: true,
        configurable: true
    });
    return Loader;
}(DisplayObjectContainer));
export { Loader };
